import { render } from "./A01Heading.vue?vue&type=template&id=0381e008&scoped=true&ts=true"
import script from "./A01Heading.vue?vue&type=script&lang=ts"
export * from "./A01Heading.vue?vue&type=script&lang=ts"

import "./A01Heading.vue?vue&type=style&index=0&id=0381e008&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0381e008"]])

export default __exports__